import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { AuthHelper, AuthUser } from '@messaia/cdk';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	providers: [FormGroupDirective]
})
export class AppComponent implements OnInit {

	/**
	 * Current user object
	 */
	public user: AuthUser = AuthHelper.user;

	/**
	 * onLogout?: function
	 * Event emitted when a meni logout is clicked.
	 */
	@Output() onLogout: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * Constructor
	 */
	constructor(
		public oidcSecurityService: OidcSecurityService,
		private router: Router,
		private iconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer
	) {
		/* Listen rou router evenets */
		this.router.events
			.subscribe((event) => {
				/* Rememeber last visitied route */
				if (event instanceof NavigationStart) {
					if (!['id_token', 'code', 'unauthorized', 'forbidden', 'login'].some(x => event.url.includes(x))) {
						localStorage.setItem('routeUrl', event.url);
					}
				}
			});
	}

	/**
	 * Lifecycle hook that is called after data-bound properties 
	 * of a directive are initialized.
	 */
	ngOnInit() {
		/* Load user data */
		this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated, userData, accessToken, idToken }) => {
			AuthHelper.user.isAuthenticated = isAuthenticated;
			if (userData) {
				AuthHelper.user = Object.assign(userData, {
					id: userData.sub,
					isAuthenticated: isAuthenticated
				});
			}
		});

		/* Register icons */
		this.iconRegistry.addSvgIconSetInNamespace('assets', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/global.svg'));
	}
}